import React, { Component } from "react";
import { withRouter } from "react-router";
import { Row, Col } from "antd";
import PropTypes from 'prop-types';
import { DisplayFlex, EllipsisUnderline, EllipsisDataValueWrapper, EllipsisContent } from "../../../../CommonComponents/commonStyles";
import {
  UserContributionDetails,
  UserDateDetails,
  ProfileSectionHeading,
  ProfileInformationHeading,
  ProfileBlockContainer,
  ProfileAddressContainer,
  AddressDetails,
  DetailsData,
  FirstColumn,
  SecondColumn,
  HorizontalDivider,
  IconContainer,
  DetailsContainer,
  DefaultIndicator,
  UserContributionContactDetails,
  FlexAuto,
  FlexBox,
  ItemWrapper,
  InlineDiv
} from "../../styles";
import EditLinkToPill from "../../../../CommonComponents/EditLinkToPill/EditLinkToPill";
import Phone from "../../../../assets/icons/phone.svg";
import DBase from "../../../../assets/icons/db_icon.svg";
import Email from "../../../../assets/icons/email.svg";
import Delivery from "../../../../assets/icons/delivery-preference.svg";
import Aggregator from "../../../../assets/icons/aggregator_leaf.svg";
import Address from "../../../../assets/icons/addresses.svg";
import history from "../../../../history/history";
import {isGeminiUser} from '../../../../utils/sessionUtil';
import { ContentMessage, Types } from "../../../../CommonComponents/ContentMessages";
import { isNewAdvent, sortAggrDates } from "../../utils";

class ContactDetails extends Component {

  constructor(props) {
    super(props);
    this.contactTitle = 'Contact Details';
    this.btnLabel = 'Edit';
    this.state = {
      countries: []
    }    
  }

  viewComponent =() =>{
    history.push('/my-profile/edit')
  }

  componentDidMount() {
    const { countries } = this.props;    
    if(countries) this.setState({
      countries: countries
    });
  }

  setContactTitle = (title='') => {
    if(title) {
      this.contactTitle = title;
    }
  }

  getContactTitle = () => {
    return this.contactTitle;
  }

  getCountry(country_id) {
    if(this.state.countries.length > 0 && country_id) {
      let country = this.state.countries.find(item => item.value == country_id);
      if(country) return country.desc;
    }

    return;
  }  

  render() {   
    //Added by Nixon - For CSR User check
    let userData = JSON.parse(sessionStorage.getItem('userData'));    
    const isAdminUser = userData?userData.csrUser:null;
    //---/Nixon
    
    const { profileSummary } = this.props.profileData;

    let numRows = profileSummary.address != null ? Math.ceil(profileSummary.address.length/3): 0;

    let address = [];

    const dataAggregators = sortAggrDates(profileSummary.dataAggregators);


    for(let i = 0; i < numRows; i++) {
      let start = i * 3;
      address.push({
        row: i + 1,
        addresses: profileSummary.address.slice(start, start + 3)
      })
    }   
    
    return (
      <div>
        <DisplayFlex data-test="contactDetailsBlock">
          <ProfileSectionHeading>            
            <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page="My Profile" property="field_type_1_title" defaultMessage="Contact Details" setTitle={this.setContactTitle} />
          </ProfileSectionHeading>
          {(isGeminiUser || !isAdminUser) &&  
          <span className="ml2">
            <EditLinkToPill                       
              data-test="linkToPill-block"
              analyticsTracking={ () => this.props.analyticsTracking('edit', this.getContactTitle(), this.btnLabel)}
              linkPathname="/my-profile/edit"
              advisorType="primary"
              active="Primary"
            />
          </span>}
        </DisplayFlex>
        <Row>
          <FirstColumn lg={9} sm={24} xs={24}>
            <DetailsContainer>
              <IconContainer>
                <img src={Phone} alt="phone" />
              </IconContainer>{" "}
              <DetailsData className="wrapContent">
                <ProfileInformationHeading className="myProfileFontFix">
                  Phone Number
                </ProfileInformationHeading>
                {(this.props.profileData.profileSummary.phone!==null)?
                
                this.props.profileData.profileSummary.phone.map(obj => {                 
                  return (
                    <UserContributionContactDetails className="myProfileContactType">
                      <FlexAuto>{obj.phoneType}:</FlexAuto>
                      <FlexBox>
                      <UserDateDetails><ItemWrapper>{obj.phone}</ItemWrapper></UserDateDetails>
                      </FlexBox>
                    </UserContributionContactDetails>
                  );
                 
                }): '-'}
              </DetailsData>
            </DetailsContainer>
            <DetailsContainer>
              <IconContainer>
                <img src={Email} alt="email"/>
              </IconContainer>
              <DetailsData className="wrapContent">
                <ProfileInformationHeading className="myProfileFontFix">Email</ProfileInformationHeading>
                {(this.props.profileData.profileSummary.email!=null)?
                
                this.props.profileData.profileSummary.email.map((obj, index) => {                  
                    return (
                      <UserContributionContactDetails className="myProfileContactType">
                        <FlexAuto>{obj.emailType}:</FlexAuto>
                        <FlexBox>
                        <UserDateDetails>
                            <EllipsisDataValueWrapper>
                              <EllipsisUnderline><ItemWrapper className="myProfileEmail">{obj.email}</ItemWrapper></EllipsisUnderline>
                              <EllipsisContent id={"anrEmailAddress" + index}>                               
                                {obj.email}
                              </EllipsisContent>
                            </EllipsisDataValueWrapper>
                          </UserDateDetails>
                         </FlexBox>
                      </UserContributionContactDetails>
                     
                    );
                }): "-"}
              </DetailsData>
            </DetailsContainer>
            {/* Data aggregator */}
            {dataAggregators.length ?
              (<DetailsContainer>
                <IconContainer>
                  <img src={DBase} alt="db" />
                </IconContainer>{" "}
                <DetailsData className="wrapContent">
                  <ProfileInformationHeading className="myProfileFontFix">
                    Data Aggregator
                    {isNewAdvent(dataAggregators) ? (
                      <InlineDiv className="ml-03">
                        <img src={Aggregator} className="aggregator_icon" alt="aggregator" />
                        <span className="aggregator_newbtn">New</span></InlineDiv>) : <></>}
                  </ProfileInformationHeading>
                  <UserDateDetails>
                    <ItemWrapper>
                      {dataAggregators.map((agg, cnt) => {
                        if (dataAggregators.length - 1 === cnt) return agg.aggrName;
                        else return agg.aggrName + ', ';
                      })}
                    </ItemWrapper>
                  </UserDateDetails>
                </DetailsData>
              </DetailsContainer>) : <></>}
            <DetailsContainer>
              <IconContainer>
                <img src={Delivery} alt="delivery"/>
              </IconContainer>{" "}
              <DetailsData className="wrapContent">
                <ProfileInformationHeading className="myProfileFontFix">
                  Delivery Preference
                </ProfileInformationHeading>

                <UserDateDetails>
                  <ItemWrapper>
                    {this.props.profileData.profileSummary.deliveryPreference!=null?this.props.profileData.profileSummary.deliveryPreference: "-"}
                  </ItemWrapper>
                </UserDateDetails>
              </DetailsData>
            </DetailsContainer>
          </FirstColumn>
          <SecondColumn lg={15} sm={24} xs={24}>
            <DetailsContainer>
              <IconContainer>
                <img src={Address} alt="address icon "/>
              </IconContainer>{" "}
              <DetailsData className="addressWrapper">
                <ProfileInformationHeading className="myProfileFontFix">Address</ProfileInformationHeading>
                <ProfileBlockContainer>                  
                  {(address.length > 0)?
                    address.map((rowobj) => {
                      return (                                             
                        <Row>
                          {
                            rowobj.addresses.map(obj => {

                              const count = profileSummary.address.length;
                              let addr = obj.addressLine1 ? obj.addressLine1: '';
                              
                              if(addr) addr = obj.addressLine2 ? `${addr}, ${obj.addressLine2}`: addr;

                              else addr = obj.addressLine2 ? obj.addressLine2: '';

                              if(addr) addr = obj.addressLine3 ? `${addr}, ${obj.addressLine3}`: addr;

                              else addr = obj.addressLine3 ? obj.addressLine3: '';

                              return(
                                <Col lg={8} sm={24} xs={24}>
                                  <ProfileAddressContainer className="addrWrapper">
                                    <DisplayFlex>
                                      <UserContributionDetails className="myProfileContactType">
                                        {obj.addressType}:
                                      </UserContributionDetails>
                                      {
                                        obj.primary == "1"
                                        && <DefaultIndicator>PRIMARY</DefaultIndicator>
                                      }
                                    </DisplayFlex>
                                    <AddressDetails><ItemWrapper>{addr},</ItemWrapper></AddressDetails>
                                    {
                                      obj.city
                                      && <AddressDetails><ItemWrapper>{obj.city},</ItemWrapper></AddressDetails>
                                    }
                                    {
                                      obj.state && obj.zipCode
                                      && <AddressDetails><ItemWrapper>{obj.state}, {obj.zipCode},</ItemWrapper></AddressDetails>
                                    }
                                    {
                                      obj.state && !obj.zipCode
                                      && <AddressDetails><ItemWrapper>{obj.state},</ItemWrapper></AddressDetails>
                                    }
                                    {
                                      !obj.state && obj.zipCode
                                      && <AddressDetails><ItemWrapper>{obj.zipCode},</ItemWrapper></AddressDetails>
                                    }                            
                                    {
                                      obj.country
                                      && <AddressDetails><ItemWrapper>{this.getCountry(obj.country)}</ItemWrapper></AddressDetails>
                                    }
                                  </ProfileAddressContainer>
                                </Col>
                              )
                            })                             
                          }
                        </Row>
                      );   
                  }): "-" }                     
                </ProfileBlockContainer>
              </DetailsData>
            </DetailsContainer>
          </SecondColumn>
        </Row>
        <HorizontalDivider />
      </div>
    );
  }
}

ContactDetails.propTypes = {
  analyticsTracking: PropTypes.func,
  profileData: PropTypes.object,
  countries: PropTypes.array
}

export default withRouter(ContactDetails);
